export default function NewBadge() {
  return (
    <span className="ml-2 inline-flex rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium leading-none text-yellow-900">
      Nuevo
    </span>
  );
}
